export default __webpack_public_path__ + "static/media/small.e8783eee.jpg";